import React from 'react';
import {Redirect, useRouteMatch} from 'react-router-dom';
import styled from 'styled-components';
import Moment from 'moment';

import CanvasProjectsScheduling from '../canvas_projects_scheduling';
import {getDayData, getDayDataLight, MIN_DATE_YEAR, YEAR_SPAN} from '../../canvas-timeline/canvas_timeline_util';

const CanvasProjectSchedulingShareStyle = styled.div`
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	align-content: stretch;
`;

export const CanvasProjectSchedulingShare = () => {
	const match = useRouteMatch();
	const shareUrl = match.params.shareUrl;

	if (!shareUrl) {
		return <Redirect to="/" />;
	}

	const minDate = Moment().year(MIN_DATE_YEAR).startOf('year');
	const maxDate = minDate.clone().add(YEAR_SPAN, 'years').endOf('year');
	const dayData = getDayData(minDate, maxDate);
	const dayDataLight = getDayDataLight(minDate, maxDate);

	return (
		<CanvasProjectSchedulingShareStyle>
			<CanvasProjectsScheduling
				match={match}
				setTimeline={() => {}}
				searchFilterValue={''}
				dayData={dayData}
				dayDataLight={dayDataLight}
				showTaskModal={() => {}}
				isProjectTimeline={false}
				timelineHeatmapData={[]}
				shareUrl={shareUrl}
				heatmapCache={new Map()}
				expansionMap={new Map()}
				onTabClick={() => {}}
				isProjectTabSelected={true}
				sharedContext={true}
			/>
		</CanvasProjectSchedulingShareStyle>
	);
};
